import axios from 'axios';
import { Actions } from 'vuex-smart-module';
import { ResponseStatuses } from '@/enums';
import { EditableCoursesRequest } from '../types';
import EditableCoursesRequestState from './state';
import EditableCoursesRequestMutations from './mutations';
import EditableCoursesRequestGetters from './getters';
import { EditableCoursesRequestService } from '../services';

const service = new EditableCoursesRequestService();

export default class EditableCoursesRequestActions extends Actions<
  EditableCoursesRequestState,
  EditableCoursesRequestGetters,
  EditableCoursesRequestMutations,
  // eslint-disable-next-line no-use-before-define
  EditableCoursesRequestActions
> {
  async get_selection_lists() {
    try {
      this.mutations.TOGGLE_SELECTION_LISTS_LOADING(true);

      const { data } = await service.get_selection_lists();

      this.mutations.SET_COURSES(data.courses);
      this.mutations.SET_STAFFS(data.staffs);
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_SELECTION_LISTS_LOADING(false);
    }
  }

  async get_courses_request(request_id: number) {
    try {
      this.mutations.TOGGLE_LOADING(true);

      const {
        data,
        code = ResponseStatuses.Fail.FORBIDDEN,
      } = await service.get_editable_courses_request(request_id);

      this.mutations.SET_TYPE(data.type === EditableCoursesRequest.CoursesTypes.PAID
        ? EditableCoursesRequest.CoursesTypes.PAID : EditableCoursesRequest.CoursesTypes.FREE);
      this.mutations.SET_ORGANIZATION(data.organization_id);

      this.mutations.SET_COURSES_REQUEST({
        request_id,
        type: data.type,
        organization_id: data.organization_id,
        staffs: data.items.staffs,
        filters: data.filters,
        courses: data.items.courses,
      });

      return code;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.request?.status;
      }
    } finally {
      this.mutations.TOGGLE_LOADING(false);
    }
  }

  async send_new_courses_request(): Promise<number> {
    try {
      const payload = {
        type: this.state.type || EditableCoursesRequest.CoursesTypes.FREE,
        send: this.state.send,
        organization_id: this.state.organization_id || 0,
        items: this.state.editable_staffs,
      };

      return await service.send_new_courses_request(payload);
    } catch (error) {
      return ResponseStatuses.Fail.INTERNAL_ERROR;
    }
  }

  async edit_courses_request(id: number): Promise<number> {
    try {
      const payload = {
        type: this.state.type || EditableCoursesRequest.CoursesTypes.FREE,
        send: this.state.send,
        organization_id: this.state.organization_id || 0,
        items: this.state.editable_staffs,
      };

      return await service.edit_courses_request(id, payload);
    } catch (error) {
      return ResponseStatuses.Fail.INTERNAL_ERROR;
    }
  }
}
